import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './Redux/Store';
import { setBrand } from './Redux/Actions/brand';
import './index.css';
import 'primereact/resources/themes/saga-green/theme.css'; //theme
import 'primereact/resources/primereact.min.css'; //core css
import 'primeicons/primeicons.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { HashRouter } from 'react-router-dom';

// Detect portal from hostname and set brand before first render
const _hostname = window.location.hostname;
if (_hostname.includes("cpfleets")) {
  store.dispatch(setBrand("cpfleets"));
} else if (_hostname.includes("combpetro") || _hostname.includes("combinepetro")) {
  store.dispatch(setBrand("combpetro"));
}
// freshfuels is the default — no dispatch needed

ReactDOM.render(
  <Provider store={store}>
    <HashRouter>
      <App />
    </HashRouter> 
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
